/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { StopBenchmarkRunResult } from '../../models/stop-benchmark-run-result';

export interface ApiAdminBenchmarkRunsRunIdStopPost$Params {
  runId: string;
}

export function apiAdminBenchmarkRunsRunIdStopPost(http: HttpClient, rootUrl: string, params: ApiAdminBenchmarkRunsRunIdStopPost$Params, context?: HttpContext): Observable<StrictHttpResponse<StopBenchmarkRunResult>> {
  const rb = new RequestBuilder(rootUrl, apiAdminBenchmarkRunsRunIdStopPost.PATH, 'post');
  if (params) {
    rb.path('runId', params.runId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<StopBenchmarkRunResult>;
    })
  );
}

apiAdminBenchmarkRunsRunIdStopPost.PATH = '/api/Admin/benchmark-runs/{runId}/stop';
